import { useMutation, useQuery } from "@apollo/client";
import { useState, createContext, useContext, useEffect } from "react";
import { GET_ALL_ERP_DATA, GET_ERP_ROLES } from "../apollo/Queries";
import { CREATE_ROLE_PROFILE, DELETE_ROLE_PROFILE, DELETE_USER_ERP_NEXT, UPDATE_USER_ERP_NEXT } from "../apollo/Mutations";
import toast from "react-hot-toast";
import { useAdmin } from "./AdminContext";
import { useDispatch } from "react-redux";
import { update_user_erp } from "../redux/messageSlice";

export const ModuleContext = createContext();

export const ModuleProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { user, all_users, fetchUsers } = useAdmin();

    const [modules, setModules] = useState([]);
    const [erpRoles, setErpRoles] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [currentProfile, setCurrentProfile] = useState(null);
    const [selectedModules, setSelectedModules] = useState([]);
    const [newProfileName, setNewProfileName] = useState([]);
    const [newProfileRoles, setNewProfileRoles] = useState([]);
    const [moduleHistory, setModuleHistory] = useState([{ modules: [], title: "All Modules" }]);
    const [currentModuleLevel, setCurrentModuleLevel] = useState(0);
    const [moduleLoading, setModuleLoading] = useState(true);
    const [profileLoading, setProfileLoading] = useState(true);
    const [isEditMode, setIsEditMode] = useState(false);
    // const [isRefreshingProfiles, setIsRefreshingProfiles] = useState(false);
    const [editingProfile, setEditingProfile] = useState(null);
    const [activeProfile, setActiveProfile] = useState(null);
    const [currentTab, setCurrentTab] = useState('core_modules');
    const [allUsers, setAllUsers] = useState(all_users);
    const [invidualUserOperation, setinvidualUserOperation] = useState(null);
    const [deleteProfilePopup, setDeleteProfilePopup] = useState(false);
    const [searchUser, setSearchUser] = useState('');
    const [autoSelectedModules, setAutoSelectedModules] = useState([]);

    useEffect(() => {
        setAllUsers(all_users);
    }, [all_users]);
    useEffect(() => {
        console.log(42, allUsers);
        
    }, [allUsers]);

    // Group search state
    const [groupInfo] = useState([]);

    // Fetch ERP profiles (for main table)
    // useQuery(GET_ERP_PROFILE_ROLES, {
    //     fetchPolicy: 'no-cache',
    //     onCompleted: (data) => {
    //         if (data?.get_erp_profile_roles?.status) {
    //             const responseData = data.get_erp_profile_roles.data || {};
    //             const profiles = responseData.profilesWithRoles || [];
    //             const groupInfo = responseData.group_info || [];

    //             const mapped = profiles.map((profile, idx) => ({
    //                 id: profile.profile || idx,
    //                 name: profile.profile,
    //                 children: Array.isArray(profile.roles)
    //                     ? profile.roles.map((role, ridx) => ({
    //                         id: `${role}`,
    //                         name: role,
    //                     }))
    //                     : [],
    //             }));
    //             setModules(mapped);
    //             setModuleHistory([{ modules: mapped, title: "All Modules" }]);
    //             setCurrentModuleLevel(0);

    //             // Store group info for search
    //             setGroupInfo(groupInfo);
    //             console.log('Group info:', groupInfo);
    //             setModuleLoading(false);
    //         }
    //     }
    // });

    const { data: erpProfilesData, refetch: refetchAllERPData } = useQuery(GET_ALL_ERP_DATA, {
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true
    });

    useEffect(() => {
        if (erpProfilesData?.get_all_erp_data?.status) {
            const responseData = erpProfilesData.get_all_erp_data.data || {};

            // Process profiles
            const profiles = responseData.profiles || [];
            const mapped = profiles.map((profile, idx) => ({
                id: profile.profile || idx,
                name: profile.profile,
                role_profile: profile.role_profile || profile.profile,
                children: Array.isArray(profile.roles)
                    ? profile.roles.map((role, ridx) => ({
                        id: `${role}`,
                        name: role,
                    }))
                    : [],
            }));
            setModules(mapped);
            setModuleHistory([{ modules: mapped, title: "All Modules" }]);
            setCurrentModuleLevel(0);

            // Process users data from the comprehensive query
            const usersFromERP = responseData.users || [];
            if (usersFromERP.length > 0) {
                const mappedUsers = usersFromERP.filter(u => u.role !== 'Public User') // Exclude Public User role
                    .map(u => ({
                        id: u.id,
                        firstname: u.firstname,
                        lastname: u.lastname,
                        name: `${u.firstname || ''} ${u.lastname || ''}`,
                        email: u.email,
                        role: u.role,
                        fnln: u.fnln,
                        is_active: u.is_active,
                        img: u.img
                            ? u.img.startsWith('https://wfss001.freeli.io/profile-pic/Photos/')
                                ? u.img
                                : `https://wfss001.freeli.io/profile-pic/Photos/${u.img}`
                            : 'https://wfss001.freeli.io/profile-pic/Photos/img.png',
                        erpNext: u.erpNext || false,
                        erpNextRoles: u.erpNextRoles || [],
                    }));
                setAllUsers(mappedUsers)
            }
            setModuleLoading(false);
        }
    }, [erpProfilesData]);

    // Fetch ERP roles (for CreateRoleProfile)
    useQuery(GET_ERP_ROLES, {
        fetchPolicy: 'cache',
        onCompleted: (data) => {
            if (data?.get_erp_roles?.status) {
                const roles = data.get_erp_roles.data || [];  //['Admin', 'Manager', 'HR', 'Sales', 'Support', 'Inventory', 'Accountant'];
                setErpRoles(roles);
                setProfileLoading(false);
            }
        }
    });

    const [updateUserERPNext, { loading: updateUserLoading }] = useMutation(UPDATE_USER_ERP_NEXT, {
        onCompleted: async (data) => {
            console.log('Update profile response data:', data);
            if (data.update_erp_user?.status) {
                toast.success(data.update_erp_user.message || 'Profile updated successfully!');

                // Check if current user's permissions were updated and update Redux
                const currentUserInUpdate = selectedUsers.find(user => user.email === user?.email);

                if (currentUserInUpdate) {
                    // When user is successfully updated, they should have erpNext: true and the assigned roles
                    // Use the profile names that were assigned as the erpNextRoles
                    let assignedRoles = [];

                    // Try to get roles from newProfileName (profile names)
                    if (newProfileName && newProfileName.length > 0) {
                        assignedRoles = Array.isArray(newProfileName) ? newProfileName : [newProfileName];
                    }
                    // If no profile names, check if we can extract from response data
                    else if (data.update_erp_user.data?.updatedUsers) {
                        const updatedCurrentUser = data.update_erp_user.data.updatedUsers.find(u => u.email === user?.email);
                        if (updatedCurrentUser && updatedCurrentUser.erpNextRoles) {
                            assignedRoles = updatedCurrentUser.erpNextRoles;
                        }
                    }

                    // console.log('Dispatching Redux update for current user with roles:', assignedRoles);
                    dispatch(update_user_erp({
                        erpNext: true,
                        erpNextRoles: assignedRoles
                    }));

                    // Show specific message for current user
                    toast.success('Your module permissions have been updated!');
                }


                // Clear selections after successful update
                setSelectedUsers([]);
                setSelectedModules([]);
                setNewProfileName([]);
                setNewProfileRoles([]);
                setAutoSelectedModules([]); // Clear auto-selected modules
                setinvidualUserOperation(null);
                setCurrentTab('core_modules')

                // Refresh both ERP profiles and users data using comprehensive query
                try {
                    // If the mutation returned updated data, use it
                    // if (data.update_erp_user.data?.updatedUsers) {
                    //     const mapped = data.update_erp_user.data.updatedUsers.map(u => ({
                    //         id: u.id,
                    //         firstname: u.firstname,
                    //         lastname: u.lastname,
                    //         name: `${u.firstname || ''} ${u.lastname || ''}`,
                    //         email: u.email,
                    //         role: u.role,
                    //         fnln: u.fnln,
                    //         img: u.img
                    //             ? u.img.startsWith('https://wfss001.freeli.io/profile-pic/Photos/')
                    //                 ? u.img
                    //                 : `https://wfss001.freeli.io/profile-pic/Photos/${u.img}`
                    //             : 'https://wfss001.freeli.io/profile-pic/Photos/img.png',
                    //         erpNext: u.erpNext || false,
                    //         erpNextRoles: u.erpNextRoles || [],
                    //     }));
                    //     setAllUsers(mapped);
                    // }
                    // else {
                    //     // Fallback: refresh all data from server
                    //     await refetchAllERPData();
                    // }



                    // Refresh ERP profiles
                    // const erpResult = 
                    await refetchAllERPData();
                    // if (erpResult.data?.get_all_erp_data?.status) {
                    //     const responseData = erpResult.data.get_all_erp_data.data;
                    //     const profiles = responseData.profiles || [];

                    //     const mapped = profiles.map((profile, idx) => ({
                    //         id: profile.profile || idx,
                    //         name: profile.role_profile || profile.profile, // show role_profile if available
                    //         role_profile: profile.role_profile || profile.profile,
                    //         children: Array.isArray(profile.roles)
                    //             ? profile.roles.map((role) => ({
                    //                 id: `${role}`,
                    //                 name: role,
                    //             }))
                    //             : [],
                    //     }));
                    //     setModules(mapped);
                    //     setModuleHistory([{ modules: mapped, title: "All Modules" }]);
                    //     setCurrentModuleLevel(0);
                    // }

                    // Close popup after successful submission
                    // setShowCreateRoleGroup(false);

                } catch (refreshError) {
                    console.error('Error refreshing data:', refreshError);
                    toast.error('Data updated but failed to refresh display. Please refresh the page.');
                }
                fetchUsers({ variables: { company_id: user?.company_id } });

                // Navigate back to main dashboard immediately after success
                setCurrentTab('core_modules');
            } else {
                toast.error(data.update_erp_user?.message || 'Failed to update profile');
            }
        },
        onError: (error) => {
            console.error('Update profile error:', error);
            toast.error(error.message || 'Something went wrong while updating profile');
        }
    });

    const [deleteUserERPNext, { loading: deleteERPLoading }] = useMutation(DELETE_USER_ERP_NEXT, {
        onCompleted: async (data) => {
            if (data.delete_erp_user?.status) {
                setSelectedUsers([]);
                setSelectedModules([]);
                setNewProfileName([]);
                setAutoSelectedModules([]);
                setCurrentTab('core_modules'); // Navigate to first page immediately
                toast.success(data.delete_erp_user.message || 'Module permissions removed successfully!');

                // Update Redux if current user's permissions were deleted
                const currentUserUpdated = selectedUsers.find(user => user.email === user?.email);
                console.log('Current user in delete operation:', currentUserUpdated);
                if (currentUserUpdated) {
                    console.log('Dispatching Redux update for current user deletion');
                    dispatch(update_user_erp({
                        erpNext: false,
                        erpNextRoles: []
                    }));
                    toast.success('Your module permissions have been removed!');
                }
                try {
                    setModuleLoading(true);
                    setinvidualUserOperation(null);
                    await refetchAllERPData();
                } catch (refreshError) {
                    console.error('Error refreshing data:', refreshError);
                    toast.error('Failed to refresh data. Please refresh the page manually.');
                } finally {
                    // Always clear loading state
                    // setIsRefreshingProfiles(false);
                }
            } else {
                toast.error(data.delete_erp_user?.message || 'Failed to remove module permissions');
            }
        },
        onError: (error) => {
            console.error('Delete ERP user error:', error);
            toast.error(error.message || 'Something went wrong while removing permissions');
        }
    });

    // CREATE_ROLE_PROFILE mutation
    const [createRoleProfile, { loading: createProfileLoading }] = useMutation(CREATE_ROLE_PROFILE, {
        onCompleted: async (data) => {
            if (data?.create_role_profile?.status) {
                const message = isEditMode
                    ? (data.create_role_profile.message || 'Role profile updated successfully!')
                    : (data.create_role_profile.message || 'Role profile created successfully!');
                toast.success(message);

                // Clear form after successful creation/update
                setNewProfileName([]);
                setNewProfileRoles([]);

                // Clear edit mode
                setIsEditMode(false);
                setEditingProfile(null);

                // Navigate back to main page
                setCurrentTab('core_modules');

                // Set loading state for profile refresh
                // setIsRefreshingProfiles(true);

                // Refresh ERP profile data to show the new profile
                try {
                    // Simple refetch without causing infinite loops
                    setModuleLoading(true);
                    await refetchAllERPData();
                    const successMessage = isEditMode ? 'Profile list updated!' : 'Profile list updated with new role profile!';
                    toast.success(successMessage);
                } catch (refreshError) {
                    console.error('Error refreshing profile data:', refreshError);
                    const warningMessage = isEditMode
                        ? 'Profile updated but list may not be updated. Please refresh the page.'
                        : 'Profile created but list may not be updated. Please refresh the page.';
                    toast.warning(warningMessage);
                } finally {
                    // Always clear loading state
                    // setIsRefreshingProfiles(false);
                }
            } else {
                const errorMessage = isEditMode
                    ? (data?.create_role_profile?.message || 'Failed to update role profile')
                    : (data?.create_role_profile?.message || 'Failed to create role profile');
                toast.error(errorMessage);
            }
        },
        onError: (error) => {
            console.error('Error creating/updating role profile:', error);
            toast.error('Network error. Please try again.');
            // setIsRefreshingProfiles(false); // Clear loading state on error
        }
    });

    // DELETE_ROLE_PROFILE mutation
    const [deleteRoleProfile, { loading: deleteProfileLoading }] = useMutation(DELETE_ROLE_PROFILE, {
        onCompleted: async (data) => {
            if (data?.delete_role_profile?.status) {
                toast.success(data.delete_role_profile.message || 'Role profile deleted successfully!');

                // Close confirmation dialog
                setDeleteProfilePopup(false);
                setActiveProfile(null);

                // Set loading state for profile refresh
                // setIsRefreshingProfiles(true);

                // Refresh ERP profile data to show the updated profile list
                try {
                    setModuleLoading(true);
                    await refetchAllERPData();
                    toast.success('Profile list updated!');
                } catch (refreshError) {
                    console.error('Error refreshing profile data:', refreshError);
                    toast.warning('Profile deleted but list may not be updated. Please refresh the page.');
                } finally {
                    // Always clear loading state
                    // setIsRefreshingProfiles(false);
                }
            } else {
                toast.error(data?.delete_role_profile?.message || 'Failed to delete role profile');
            }
        },
        onError: (error) => {
            console.error('Error deleting role profile:', error);
            toast.error('Network error. Please try again.');
            // setIsRefreshingProfiles(false); // Clear loading state on error
            setDeleteProfilePopup(false);
            setActiveProfile(null);
        }
    });

    return (
        <ModuleContext.Provider value={{
            user, allUsers, moduleLoading, profileLoading, modules, setModules, selectedUsers, setSelectedUsers, editingProfile, setEditingProfile, currentProfile, setCurrentProfile,
            erpRoles, groupInfo, selectedModules, setSelectedModules, newProfileName, setNewProfileName, newProfileRoles, setNewProfileRoles, moduleHistory, setModuleHistory, currentModuleLevel,
            setCurrentModuleLevel, deleteUserERPNext, deleteERPLoading, isEditMode, setIsEditMode, updateUserERPNext, updateUserLoading, createRoleProfile, createProfileLoading, currentTab,
            setCurrentTab, invidualUserOperation, setinvidualUserOperation, activeProfile, setActiveProfile, deleteRoleProfile, deleteProfileLoading, deleteProfilePopup, setDeleteProfilePopup,
            setModuleLoading, refetchAllERPData, searchUser, setSearchUser, autoSelectedModules, setAutoSelectedModules
        }}>
            {children}
        </ModuleContext.Provider>
    );
};


export const useModule = () => {
    const context = useContext(ModuleContext);
    if (!context) {
        throw new Error("useModule must be used within a ModuleProvider");
    }
    return context;
}